// @flow

import _ from 'lodash/fp';
import React from 'react';
import classNames from 'classnames';
import './ProductSlots.css';
import type {
  ProductSlotDto,
} from '../../dtos';

export type Props = {
  productSlots: ProductSlotDto[],
  selectedProductSlot: ?ProductSlotDto,
  onSelectProductSlot: (productSlot: ProductSlotDto) => any,
  onAddProductSlot: () => any,
};

const ProductSlots = ({
  productSlots,
  onSelectProductSlot,
  onAddProductSlot,
  selectedProductSlot,
}: Props) => (
  <div className="ProductSlots">
    <div className="title">
      <span>Produktplatser</span>
    </div>
    <div className="slots">
      {_.map(s => (
        <div
          key={s.id}
          className="slot">
          <div
            className={classNames({
              active: selectedProductSlot && selectedProductSlot.id === s.id,
              'slot-label': true,
            })}
            onClick={() => onSelectProductSlot(s)}>
            {s.name}
          </div>
        </div>
      ), productSlots)}
      {!productSlots.length &&
        <div className="no-slot-label">Inga produktplatser</div>
      }
    </div>
    <div className="tools">
      <button
        onClick={() => onAddProductSlot()}
        disabled={!!(selectedProductSlot && !selectedProductSlot.id)}
        type="button"
        className="button small expanded">
        Lägg till produktplats
      </button>
    </div>
  </div>
);

export default ProductSlots;



// WEBPACK FOOTER //
// ./src/components/ProductSlots/ProductSlots.js